import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useData } from '../hooks/useData';
import { useUserData } from '../hooks/useUserData';
import * as Utils from '../utils/general';
import AppContent from './AppContent';
import Error from './Error';
import FeatureTable from './FeatureTable';
import Skeleton from './Skeleton';
import Wrapper from './Wrapper';

export default function App({ dataURL }) {
	const { data, loading, error } = useData(dataURL);
	const [isLoading, setIsLoading] = useState(true);
	const userDataActions = useUserData();
	const getLabel = (key) => Utils.getLabel(data?.labels, key);

	useEffect(() => {
		if (document.startViewTransition && document.visibilityState === 'visible') {
			document.startViewTransition(() => {
				flushSync(() => {
					setIsLoading(loading);
				});
			});
		} else {
			setIsLoading(loading);
		}
	}, [loading]);

	if (isLoading) {
		return (
			<Wrapper step={userDataActions.userData.step}>
				<Skeleton />
				<FeatureTable getLabel={getLabel} />
			</Wrapper>
		);
	}

	if (error) {
		return (
			<Wrapper step={userDataActions.userData.step}>
				<Error error={error} />
			</Wrapper>
		);
	}

	if (!data && !isLoading) {
		return (
			<Wrapper step={userDataActions.userData.step}>
				<Error error={error} />
			</Wrapper>
		);
	}

	return <AppContent data={data} getLabel={getLabel} userDataActions={userDataActions} />;
}
